import React from 'react';
import { KompisText, KompisPrompt } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

export default class LoadingError extends React.Component {
  render() {
    return (
      <KompisPrompt
        visible={true}
        disableIframeSticky={true}
        theme={SkapaTheme}
        heading={'Loading error'}
      >
        <KompisText theme={SkapaTheme}>
          {
            "Some of the application's modules could not be loaded. Please contact customer support if the problem persists."
          }
        </KompisText>
      </KompisPrompt>
    );
  }
}
